import React from "react";
import { Main } from './commonStyles';
import Welcome from "./Welcome";


export default function Home({content, sectionLookup, windowWidth, smallWindow}) {
    
    return(
        <Main content={content.styles}>
            <Welcome content={content} windowWidth={windowWidth} smallWindow={smallWindow}/>
                
            {content.sections.map((item) => {
                if (content.sectionsEnabled[item] && content.welcome.sectionsEnabled[item]) {
                    return (
                        <div key={item}>
                            <p>&nbsp;</p>
                            <hr color={content.styles.highlightColor}></hr>
                            {sectionLookup[item]}
                            
                        </div>
                    )
                } else {
                    return null;
                }
            })}
        </Main>
    )
}
